import warn from '../warn';
import { defaultLocale } from './consts';
export var createTranslationLoader = function createTranslationLoader(_ref) {
  var translationFileLoader = _ref.translationFileLoader;
  return function (locale) {
    try {
      return translationFileLoader({
        locale: locale
      });
    } catch (e) {
      warn("Locale has changed to '".concat(locale, "' but the component doesn't have the correct localization file for it."));
      return translationFileLoader({
        locale: defaultLocale
      });
    }
  };
};
//# sourceMappingURL=TLoader.js.map